export default "__VITE_ASSET__l31Rv021__"